import { Component, OnInit, Inject } from '@angular/core';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material';

@Component({
  selector: 'app-delink-device-dialog',
  templateUrl: './delink-device-dialog.component.html',
  styleUrls: ['./delink-device-dialog.component.css']
})
export class DelinkDeviceDialogComponent {
  device_id: number;
  constructor(
    public dialogRef: MatDialogRef<DelinkDeviceDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) { }

    onNoClick(): void {
      this.dialogRef.close();
    }
}



// WEBPACK FOOTER //
// ./src/app/delink-device-dialog/delink-device-dialog.component.ts